import EventiPageComponent from "./components/EventiPageComponent";
import { useSelector } from "react-redux";
import axios from "axios";


const getEventtypes = async (abctrl) => {
    const {data} = await axios.get("/api/eventtypes", {
        signal: abctrl.signal,
    });
    return data
}

const EventiPage = () => {

    const { categories } = useSelector((state) => state.getCategories);

  return <EventiPageComponent getEventtypes={getEventtypes}/>;
};

export default EventiPage;
